import type { AccountRole as AccountRoleModel } from '@/adapters/catalogv1.g';

export function extractAccountRole(model: AccountRoleModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    roleRef: model.role_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountRole = ReturnType<typeof extractAccountRole>;
